"use client";

import { useTranslations } from "next-intl";
import { useActionState } from "react";
import type { ActionState } from "@/components/forms/action-state.type";
import { Button } from "@/components/ui/button";
import { confirmSubscriptionAction } from "./confirm-subscription-action";

/** The button of the confirm page: the sign-up is confirmed only when it is pressed, never by opening the link. */
export function ConfirmForm({ token, locale }: { token: string; locale: string }) {
  const t = useTranslations("publicBlog.newsletter.confirm");
  const [state, send, pending] = useActionState(confirmSubscriptionAction.bind(null, token, locale), {} as ActionState);
  return (
    <form action={send} className="flex max-w-xl flex-col gap-3">
      {state.error && <p role="alert">{t("bad")}</p>}
      <div className="flex justify-end"><Button type="submit" disabled={pending}>{t("button")}</Button></div>
    </form>
  );
}
